(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/input-number/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/components/components/input-number/assets/javascripts/utils.js');
"use strict";


(function (svs) {
  function isWithinBounds(value, props) {
    const _props$minValue = props.minValue,
      minValue = _props$minValue === void 0 ? value : _props$minValue,
      _props$maxValue = props.maxValue,
      maxValue = _props$maxValue === void 0 ? value : _props$maxValue;
    return value >= minValue && value <= maxValue;
  }
  function isNumber(num) {
    return typeof num === 'number' && isFinite(num) && Math.floor(num) === num;
  }
  function getValidValue(currentValue, previousValue, props) {
    const _props$minValue2 = props.minValue,
      minValue = _props$minValue2 === void 0 ? -Infinity : _props$minValue2,
      _props$maxValue2 = props.maxValue,
      maxValue = _props$maxValue2 === void 0 ? Infinity : _props$maxValue2;
    if (!isNumber(currentValue)) {
      return previousValue;
    }
    return currentValue < minValue ? minValue : currentValue > maxValue ? maxValue : currentValue;
  }
  svs.components.input_number.utils = {
    isWithinBounds,
    isNumber,
    getValidValue
  };
})(svs);

 })(window);